import styled from "styled-components";
import { mobile, tablet } from "../responsive";

const Image = styled.img`
    object-fit: cover;
    opacity: 0.55;
    width: 100%;
    height: 100%;
    display: block;
`;

const Header = styled.div`
    height: 60vh;
    width: 100%;
    background: var(--brand-black);
    position: relative;
    overflow: hidden;
    display: none;
    border-bottom: 1px solid var(--brand-rule);
    ${mobile({ height: "55vh", display: "block" })}

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
            to top,
            var(--brand-black) 0%,
            rgba(10, 10, 10, 0.4) 50%,
            rgba(10, 10, 10, 0.25) 100%
        );
        pointer-events: none;
    }
`;

const Title = styled.h1`
    text-transform: uppercase;
    padding: 0 1rem;
    font-family: "FuturaPT-Bold", sans-serif;
    font-size: 2rem;
    margin: 0;
    color: var(--brand-white);
    letter-spacing: 0.08em;
    text-align: center;
    ${tablet({ fontSize: "2.5rem" })}
`;

const Section = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--brand-white);
    z-index: 1;
    width: 90%;
`;

const HomeBannerOverlay = ({ imageUrl, title }) => {
    const hasTitle = Boolean(title && String(title).trim());

    return (
        <Header>
            <Image src={imageUrl} alt={hasTitle ? title : "D&Dream Property"} />
            {hasTitle && (
                <Section>
                    <Title>{title}</Title>
                </Section>
            )}
        </Header>
    );
};

export default HomeBannerOverlay;
